import { CommonModule } from '@angular/common';
import { GenerationLoaderComponent } from '@games/menar/shared/components/generation-loader/generation-loader.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileTooltipTriggerDirective } from '@shared/directives';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { AnswerResultFormModule } from '@new-core/components/game-forms/answer-result-form/answer-result-form.module';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  TimerModule,
} from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { ResultFormBgModule } from '../../../../new-core/components/game-forms/result-form-bg/result-form-bg.module';
import { ColumnsControllerComponent } from './columns-controller/columns-controller.component';
import { ColumnsCorrectAnswerPreviewComponent } from './columns-preview/columns-answer-preview/columns-answer-preview.component';
import { ColumnsExamplePreviewComponent } from './columns-preview/columns-example-preview/columns-example-preview.component';
import { ColumnsParametersPreviewComponent } from './columns-preview/columns-parameters-preview/columns-parameters-preview.component';
import { ColumnsUserAnswerPreviewComponent } from './columns-preview/columns-user-answer-preview/columns-user-answer-preview.component';
import { ColumnsSettingsComponent } from './columns-settings/columns-settings.component';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    ColumnsControllerComponent,
    ColumnsSettingsComponent,
    ColumnsCorrectAnswerPreviewComponent,
    ColumnsExamplePreviewComponent,
    ColumnsParametersPreviewComponent,
    ColumnsUserAnswerPreviewComponent,
  ],
  exports: [
    ColumnsControllerComponent,
    ColumnsSettingsComponent,
    ColumnsCorrectAnswerPreviewComponent,
    ColumnsExamplePreviewComponent,
    ColumnsParametersPreviewComponent,
    ColumnsUserAnswerPreviewComponent,
  ],
  imports: [
    GenerationLoaderComponent,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    CalculatorModule,
    DefaultImageModule,
    FormFieldModule,
    ButtonModule,
    TimerModule,
    FitTextModule,
    MatTooltipModule,
    MobileTooltipTriggerDirective,
    GameInputComponent,
    GameButtonComponent,
    ResultFormBgModule,
    AnswerEntryFormComponent,
    AnswerResultFormModule,
    GamesSharedModule,
    CalculatorLayoutComponent,
  ],
})
export class ColumnsModule {}
